function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.67864 11.5464C8.44045 11.7938 8.44045 12.2062 8.67864 12.4536L13.8129 17.8144C14.0775 18.0619 14.4745 18.0619 14.7127 17.8144L15.3214 17.1821C15.5595 16.9347 15.5595 16.5223 15.3214 16.2474L11.2457 12.0137L15.3214 7.75258C15.5595 7.47766 15.5595 7.06529 15.3214 6.81787L14.7127 6.18557C14.4745 5.93814 14.0775 5.93814 13.8129 6.18557L8.67864 11.5464Z",
  fill: "#637381"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _ref);

export default __webpack_public_path__ + "static/media/chevron-left.96f803cc.svg";
export { SvgComponent as ReactComponent };